/** Fills match public/images/compsBorder.svg and potentialCompsBorder.svg. */
export const ACTUAL_COMP_MARKER_COLOR = '#2a2e31'
export const POTENTIAL_COMP_MARKER_COLOR = '#f4772e'

export function compMarkerColor(isPotential) {
  return isPotential ? POTENTIAL_COMP_MARKER_COLOR : ACTUAL_COMP_MARKER_COLOR
}
